// src/components/ProtectedRoute/ProtectedRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authApi from '../../api/authApi';

const ProtectedRoute = ({ children }) => {
    const [state, setState] = useState({ loading: true, authed: false });

    useEffect(() => {
        let mounted = true;
        authApi.me()
            .then(() => mounted && setState({ loading: false, authed: true }))
            .catch(() => mounted && setState({ loading: false, authed: false }));
        return () => { mounted = false; };
    }, []);

    if (state.loading) return null; // или спиннер

    return state.authed ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
